<!--
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-10-17 20:49:05
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-10-20 10:26:23
 * @FilePath: \web\src\components\Administrator\Project.vue
 * @Description: 项目管理
-->
<template>
  <div>
    <div class="top-header">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch">
        <el-form-item label="名称" prop="name">
          <el-input v-model="queryParams.name" placeholder="请输入名称" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <div style="padding-top: 3px; margin-right: 30px;">
        <el-button size="mini" type="success" @click="handleAdd">添加项目</el-button>
      </div>
    </div>
    <div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="" v-if="false" width="180">
        </el-table-column>
        <el-table-column prop="serial" align="center" label="项目序号" width="160">
        </el-table-column>
        <el-table-column prop="code" align="center" label="项目编号" width="160">
        </el-table-column>
        <el-table-column prop="name" align="center" label="名称" width="180">
        </el-table-column>
        <el-table-column prop="form" align="center" label="项目形式" width="160">
        </el-table-column>
        <el-table-column prop="charger" align="center" label="负责人" width="100">
        </el-table-column>
        <el-table-column prop="startTime" align="center" label="开始时间" width="140">
        </el-table-column>
        <el-table-column prop="endTime" align="center" label="结束时间" width="140">
        </el-table-column>
        <el-table-column prop="mark" label="备注" :show-overflow-tooltip="true" width="200">
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="创建时间" width="160">
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="200" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改</el-button>
            <el-button v-if="scope.row.children == null || scope.row.children == undefined" size="mini" type="text"
              icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :page-sizes="[10, 20, 50]" :page-size="queryParams.pageSize"
        :current-page.sync="queryParams.currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :pager-count="5" layout="sizes, prev, pager, next" :total="queryParams.total">
      </el-pagination>
    </div>

    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row>
          <el-col :span="24" v-if="form.id == undefined">
            <el-form-item label="项目序号" prop="serial">
              <el-input v-model="form.serial" placeholder="请输入项目序号" />
            </el-form-item>
          </el-col>
          
          <el-col :span="24">
            <el-form-item label="项目编号" prop="code">
              <el-input v-model="form.code" placeholder="请输入项目编号" />
            </el-form-item>
          </el-col>
          
          <el-col :span="24">
            <el-form-item label="项目名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入项目名称" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="项目形式" prop="form">
              <el-input v-model="form.form" placeholder="请输入项目形式" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="负责人" prop="charger">
              <el-input v-model="form.charger" placeholder="请输入项目负责人" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="开始时间" prop="startTime">
              <!-- <el-input v-model="form.startTime" placeholder="请输入项目开始时间" /> -->
              <el-date-picker
                v-model="form.startTime"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="结束时间" prop="endTime">
              <!-- <el-input v-model="form.endTime" placeholder="请输入项目结束时间" /> -->
              <el-date-picker
                v-model="form.endTime"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="备注" prop="mark">
              <el-input type="textarea" autosize v-model="form.mark" placeholder="请输入项目备注" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addProject, updateProject, deleteProjects, getProjectList } from '@/api/project.js'

export default {
  name: '',
  data () {
    return {
      queryParams: {
        name: '',
        pageSize: 10,
        total: 10,
        currentPage: 1
      },
      tableData: [],
      form: {
        id: undefined,
        serial: undefined,
        code: undefined,
        name: '',
        form: '',
        charger: '',
        startTime: '',
        endTime: '',
        mark: ''
      },
      showSearch: true,
      title: '',
      open: false,
      rules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '项目编号不能为空', trigger: 'blur' }
        ],
        form: [
          { required: true, message: '项目形式不能为空', trigger: 'blur' }
        ],
        charger: [
          { required: true, message: '项目负责人不能为空', trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: '项目开始时间不能为空', trigger: 'blur' }
        ],
      },
    };
  },
  created () { }, // 生命周期 - 创建完成
  mounted () {
    this.search();
  }, // 生命周期 - 挂载完成
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { }, // 如果页面有keep-alive缓存功能，这个函数会触发
  components: {},
  watch: {}, // 监控data中的数据变化
  computed: {}, // 计算属性，会监听依赖属性值随之变化
  methods: {
    handleAdd () {
      console.log("add .... ")
      this.open = true;
      this.title = '添加项目';
    },
    reset () {
      this.form = {
        id: undefined,
        serial: undefined,
        code: undefined,
        name: '',
        form: '',
        charger: '',
        startTime: '',
        endTime: '',
        mark: ''
      };
      this.queryParams = {
        name: '',
        pageSize: 10,
        total: 10,
        currentPage: 1
      }
    },
    handleUpdate (data) {
      this.form = data;
      this.title = '修改项目';
      this.open = true;
    },
    handleDelete (data) {
      let ids = [data.id];
      deleteProjects(ids).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.resetQuery();
          this.search();
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    submitForm () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.id != undefined) {
            // 更新
            updateProject(this.form).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '修改成功'
                })
                this.open = false;
                this.reset();
                this.search();
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          } else {
            // 添加
            addProject(this.form).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '修改成功'
                })
                this.open = false;
                this.reset();
                this.search();
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }
        }
      })
    },
    cancel () {
      this.open = false;
      this.resetQuery();
    },
    search () {
      getProjectList(this.queryParams).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.queryParams.total = res.data.total;
          this.queryParams.currentPage = res.data.current;
          this.queryParams.pageSize = res.data.size;
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    handleQuery () {
      this.search();
    },
    resetQuery () {
      this.queryParams.name = '';
      this.search();
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val;
      this.search();
    },
    handleCurrentChange (val) {
      this.queryParams.currentPage = val;
      this.search();
    },
  }, // 方法集合
}

</script>
<style lang='less' scoped>
.top-header {
  display: flex;
  justify-content: space-between;
}
</style>